import { render, staticRenderFns } from "./PopUpComponent.vue?vue&type=template&id=5e36f2be&scoped=true"
import script from "./PopUpComponent.vue?vue&type=script&lang=js"
export * from "./PopUpComponent.vue?vue&type=script&lang=js"
import style0 from "./PopUpComponent.vue?vue&type=style&index=0&id=5e36f2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36f2be",
  null
  
)

export default component.exports